import script from "./colorcardQrcodeList.vue?vue&type=script&setup=true&lang=js"
export * from "./colorcardQrcodeList.vue?vue&type=script&setup=true&lang=js"

import "./colorcardQrcodeList.vue?vue&type=style&index=0&id=b9d95fcc&lang=scss&scoped=true"
import "./colorcardQrcodeList.vue?vue&type=style&index=1&id=b9d95fcc&lang=css"

import exportComponent from "C:\\Users\\86183\\Desktop\\yw-admin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b9d95fcc"]])

export default __exports__